<template>
  <el-date-picker
    v-if="type === 'date'"
    ref="datepicker"
    v-model="currentValue"
    type="date"
    format="dd-MM-yyyy"
    value-format="yyyy-MM-dd"
    :clearable="clearable"
    :readonly="readonly"
    :picker-options="pickerOptions"
    :placeholder="placeholder"
    @input="handleModelInput"
  />
  <el-date-picker
    v-else-if="type === 'week'"
    ref="datepicker"
    v-model="currentValue"
    type="week"
    format="week W"
    value-format="yyyy-MM-dd"
    placeholder="Week"
    :disabled="disabled"
    :clearable="clearable"
    :readonly="readonly"
    :picker-options="pickerOptions"
    @input="handleModelInput"
  />
</template>

<script>
import { disableAutocompleteInEl, removeChildrenWithClassName } from '@/utils';
import { drawWeekNumbers } from './WeekPicker/week-utils';

export default {
  props: {
    clearable: {
      default: true,
      type: Boolean
    },
    placeholder: {
      default: '',
      type: String
    },
    disabled: Boolean,
    readonly: Boolean,
    value: [String, Number, Date],
    showWeekNumbers: {
      type: Boolean,
      default: true
    },
    type: {
      default: 'date',
      type: String
    }
  },
  data() {
    return {
      currentValue: this.value,
      pickerOptions: {
        firstDayOfWeek: 1
      }
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  mounted() {
    disableAutocompleteInEl(this.$el);
    if (this.showWeekNumbers) {
      this.$watch('$refs.datepicker.pickerVisible', this.handlePickerVisible);
    }
  },
  methods: {
    getDisplayValue() {
      const picker = this.$refs.datepicker;
      return picker && picker.displayValue;
    },
    handleDrawWeekNumbers() {
      if (!this.picker) {
        return;
      }
      const className = 'date-picker-week-table';
      const panel = this.picker.$el.querySelector('.el-picker-panel__content');

      removeChildrenWithClassName(panel, className);
      if (this.picker.currentView !== 'date') {
        return;
      }
      drawWeekNumbers(panel, this.picker.date);
    },
    handlePickerDateChange(panel, date) {
      this.handleDrawWeekNumbers();
    },
    handlePickerCurrentViewChange(type) {
      this.handleDrawWeekNumbers();
    },
    handlePickerVisible() {
      const { picker } = this.$refs.datepicker;
      if (!picker) {
        return;
      }
      if (!this.picker || this.picker._uid !== picker._uid) {
        this.picker = picker;
        picker.$watch('date', this.handlePickerDateChange);
        picker.$watch('currentView', this.handlePickerCurrentViewChange);
      }
    },
    handleModelInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss">
.date-picker-week-table {
  font-size: 12px;
  table-layout: fixed;
  user-select: none;
  width: 40px;
  border-spacing: 0;
  border-collapse: collapse;
  display: inline;
  font-weight: 700;
  th {
    padding: 5px;
    border-bottom: solid 1px #ebeef5;
  }

  td {
    width: 32px;
    height: 30px;
    padding: 4px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    position: relative;
  }
  th,
  td {
    font-style: italic;
    color: #a2a2a2;
    background-color: #fafafa;
    border-right: solid 1px #ebeef5;
  }
}
.el-date-picker {
  .date-picker-week-table + .el-date-table {
    display: inline;

    th {
      padding: 5px 10px;
    }
  }
}
</style>
